import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityMonitoredObjectsSlice } from './get';
import { postCoreDataSecurityMonitoredObjectsSlice } from './post';

export const coreDataSecurityMonitoredObjectsReducers = combineReducers({
	get: getCoreDataSecurityMonitoredObjectsSlice.asyncReducers,
	post: postCoreDataSecurityMonitoredObjectsSlice.asyncReducers
});

export const coreDataSecurityMonitoredObjectsWatchers = combineAllWatchers([
	getCoreDataSecurityMonitoredObjectsSlice.asyncWatchers,
	postCoreDataSecurityMonitoredObjectsSlice.asyncWatchers
]);
